
import { LoginForm } from "./auth/LoginForm";
import { RegisterForm } from "./auth/RegisterForm";

interface AuthFormProps {
  mode: "login" | "register";
  onSubmit: (data: any) => void;
  onToggleMode: () => void;
  onGoogleSignIn?: () => void;
  onGoogleSignUp?: () => void;
  isLoading?: boolean;
}

export function AuthForm({ 
  mode, 
  onSubmit, 
  onToggleMode, 
  onGoogleSignIn, 
  onGoogleSignUp,
  isLoading = false 
}: AuthFormProps) {
  return mode === "login" ? (
    <LoginForm 
      onSubmit={onSubmit} 
      onToggleMode={onToggleMode}
      onGoogleSignIn={onGoogleSignIn || (() => {})}
      isLoading={isLoading}
    />
  ) : (
    <RegisterForm 
      onSubmit={onSubmit} 
      onToggleMode={onToggleMode}
      onGoogleSignUp={onGoogleSignUp || (() => {})}
      isLoading={isLoading}
    />
  );
}
